const timezones = {
  // North America
  "America/New_York": "Eastern Time (US & Canada)",
  "America/Chicago": "Central Time (US & Canada)",
  "America/Denver": "Mountain Time (US & Canada)",
  "America/Los_Angeles": "Pacific Time (US & Canada)",
  "America/Phoenix": "Arizona",
  "America/Anchorage": "Alaska",
  "Pacific/Honolulu": "Hawaii",

  // Latin America
  "America/Mexico_City": "Mexico City",
  "America/Santiago": "Santiago",
  "America/Argentina/Buenos_Aires": "Buenos Aires",
  "America/Sao_Paulo": "Sao Paulo",

  // Europe & Africa
  "Europe/London": "London, Dublin, Lisbon",
  "Europe/Paris": "Paris, Berlin, Rome, Madrid",
  "Europe/Helsinki": "Helsinki, Athens, Kyiv",
  "Europe/Moscow": "Moscow, Istanbul",
  "Africa/Johannesburg": "Johannesburg, Cairo",

  // Middle East & India
  "Asia/Dubai": "Dubai, Abu Dhabi",
  "Asia/Kolkata": "Mumbai, New Delhi",

  // Asia
  "Asia/Bangkok": "Bangkok, Jakarta, Hanoi",
  "Asia/Shanghai": "Beijing, Shanghai, Singapore, Hong Kong",
  "Asia/Tokyo": "Tokyo, Seoul",

  // Australia & Pacific
  "Australia/Perth": "Perth",
  "Australia/Sydney": "Sydney, Melbourne",
  "Australia/Brisbane": "Brisbane",
  "Pacific/Auckland": "Auckland",
};

export default timezones;
